import { Injectable } from '@angular/core';
import { QuestionElement } from '../../question-base';
import { NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalContentComponent } from '../../modal-content/modal-content.component';

interface MODAL {
  id: string, 
  subQuestions: Array<QuestionElement> 
}

@Injectable()
export class ModalService {
  
  private modals: Array<MODAL> = [];

  constructor(
    private ngbModalService : NgbModal
  ) {
    
  }

  public setQuestions( thisId: string, qs: Array<QuestionElement> ){   
    this.modals.push({
      id: thisId,
      subQuestions: qs
    });
  }
  
  public getQuestions(id){
    let arr : Array<any> = this.modals.filter(modal => modal.id === id);
    
    if( arr.length !== 1 ){
      console.error("Modal IDs don't match.")
    }
    
    return arr.pop().subQuestions;
  }
  
  public openModal(id, form) : Promise<any> {
    const modalRef : NgbModalRef = this.ngbModalService.open( ModalContentComponent, { size: 'lg', backdrop: 'static' });
    
    let subQuestions = this.getQuestions(id);
    modalRef.componentInstance.subQuestions = subQuestions;
    modalRef.componentInstance.form = form;
    
    return modalRef.result;
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/modal/modal.service.ts